import { useHistory } from 'react-router-dom';
import urlJoin from 'url-join';
import { QUOTE_APP_ROUTE } from 'Shared/constants/routes';
import { getErrorStatusCode } from 'QuoteApp/utils';
import { useState } from 'react';

export type AgentUnauthorizedType = {
  isUnauthorized: boolean;
  handleUnauthorizedAgent(e: any): boolean;
};

export const isAgentUnauthorized = (e: any) => {
  return (
    getErrorStatusCode(e) === 403 ||
    e.message === 'The request is not authorized.'
  );
};

export const useAgentUnauthorized = (appId: string): AgentUnauthorizedType => {
  const history = useHistory();
  const [isUnauthorized, setIsUnauthorized] = useState<boolean>(false);

  const handleUnauthorizedAgent = (e: any): boolean => {
    const isUnauthorized = isAgentUnauthorized(e);
    setIsUnauthorized(isUnauthorized);
    if (isUnauthorized) {
      history.replace(urlJoin(QUOTE_APP_ROUTE, appId, '/not_authorized'));
    }
    return isUnauthorized;
  };

  return {
    isUnauthorized,
    handleUnauthorizedAgent,
  };
};
